import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { notInPlanMessage } from "@utils/planFeatures";
import type { ProjectNavChild } from "./projectNavItems";
import NavCountPill from "./NavCountPill";

interface Props {
  child: ProjectNavChild;
  href: string;
  style: React.CSSProperties;
  onNavigate: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  count?: number;
}

const hover = (color: string) => (e: React.MouseEvent<HTMLElement>) => {
  e.currentTarget.style.backgroundColor = color;
};

// One entry in a project-nav dropdown: a link, or, when the account's plan
// lacks the feature, a locked item carrying the support note.
const ProjectNavChildLink = ({ child, href, style, onNavigate, count }: Props) => {
  if (child.locked) {
    const note = notInPlanMessage(child.requiresEntitlement?.[0] ?? "");
    return (
      <span
        id={child.id}
        role="link"
        aria-disabled="true"
        tabIndex={0}
        title={note}
        aria-label={`${child.label}. ${note}`}
        style={{ ...style, color: "#9AA0B4", cursor: "not-allowed" }}
      >
        <FontAwesomeIcon icon={faLock} style={{ marginRight: 8 }} />
        {child.label}
      </span>
    );
  }

  return (
    <a
      id={child.id}
      href={href}
      style={style}
      onClick={onNavigate}
      onMouseEnter={hover("rgba(0,0,0,0.04)")}
      onMouseLeave={hover("transparent")}
      aria-label={count && count > 0 ? `${child.label}, ${count}` : undefined}
    >
      {child.label}
      <NavCountPill count={count} />
    </a>
  );
};

export default ProjectNavChildLink;
